"use client";

import styled from "styled-components";

export const Form = styled.form`
  max-width: 850px;
  width: 100%;
`;
